module.exports = __webpack_public_path__ + "img/teachers.17c7ff25.png";